import { useCallback, useEffect, useState } from "react";

const readStoredBoolean = (key: string, fallback: boolean) => {
  if (typeof window === "undefined") {
    return fallback;
  }
  const stored = window.localStorage.getItem(key);
  if (stored === null) {
    return fallback;
  }
  return stored === "true";
};

export const usePersistentBooleanState = (key: string, fallback = false) => {
  const [value, setValue] = useState(() => readStoredBoolean(key, fallback));

  useEffect(() => {
    setValue(readStoredBoolean(key, fallback));
  }, [key, fallback]);

  const setPersistentValue = useCallback(
    (next: boolean) => {
      setValue(next);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, String(next));
      }
    },
    [key],
  );

  return {
    value,
    setPersistentValue,
  };
};
